'use client';

import { PublicOccurrence } from '@cademy-package/sdk-component-types';
import { useMemo } from 'react';

const haveOccurrenceOffersExpired = (occurrence: PublicOccurrence): boolean => {
    if (!occurrence.offers) {
        return false;
    }

    return occurrence.offers.every((offer) => {
        return offer.end_at && offer.end_at <= Math.floor(Date.now() / 1000);
    });
};

export type useOccurrencesWithoutExpiredOffersProps = {
    occurrences: PublicOccurrence[];
};

export const useOccurrencesWithoutExpiredOffers = ({
    occurrences,
}: useOccurrencesWithoutExpiredOffersProps) => {
    return useMemo(() => {
        return occurrences.filter(
            (occurrence) => haveOccurrenceOffersExpired(occurrence) === false
        );
    }, [occurrences]);
};
